import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import axios from '@/common/axios'


const LOGOUT_USER = 'LOGOUT_USER'


const usernumber_obj = {
    namespaced: true,
    state: {
        usernumber: []
    },
    mutations: {
        LOGOUT_USER (state) {
            state.usernumber = []
        }
    },
    getters: {
        usernumber (state) {
            return state.usernumber
        }
    },
    actions: {
        // API Calls
        async getAllUsernumber ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('usernumber', {params: {round: data.round, order: data.order, page: data.page, limit: data.limit}})
                //console.log('getAllUsernumber: ', response)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },
        async getUsernumber ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('usernumber/' + data)
                //console.log('getusernumber: ', response)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },
        async createUsernumber ({ dispatch, commit, getters, rootGetters }, data) {
            //console.log('createusernumber data: ', data)
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.post('usernumber', data)
                return response.data
            } catch (error) {
                throw error
            }
        },
        async saveUsernumber ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                return await axios.put('usernumber/' + data.id, { bet_value: data.bet_value, current_limit: data.current_limit })
            } catch (error) {
                throw new Error(error)
            }
        },
        async deleteUsernumber ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.delete('usernumber/' + data.id)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },

        // Only Mutations
        async userLogout ({ dispatch, commit, getters, rootGetters }) {
            try {
                commit(LOGOUT_USER)
            } catch (error) {
                throw new Error(error)
            }
        },
    }
}

export default usernumber_obj
